// extracted by mini-css-extract-plugin
export default {"image":"Uea-z","loaded":"Vea-z"};